import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PaymentService, ProductDisplay } from '../payment.service';
import { AuthResponse, AuthService, UserInfo } from '../../auth/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'settings',
  standalone: true,
  imports:[CommonModule, RouterLink, FormsModule],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit{

  activeSection: string = 'account';
  activeSubs: ProductDisplay[];
  accountUpdated: boolean = false;
  userInfo: UserInfo;

  constructor(private paymentService: PaymentService, private route: ActivatedRoute, private authService: AuthService){}

  async updateUsername(){
    if(this.userInfo.username.length < 2){
      this.authService.openSnackBar('Username must be longer', 'Ok');
      return;
    }
    
    const response = await this.authService.updateUsername(this.userInfo.username);
    if(response && response.result){
      this.userInfo.username = response.message
      this.accountUpdated = true;
      setTimeout(() =>{
        this.accountUpdated = false;

      }, 5000);
      return;
    }

    this.authService.openSnackBar('There was an issue updating profile','Ok');
  }

  openCustomerPortal(){
    this.paymentService.openCustomerPortal();
  }

  async requestAccountDeletion(){
    let result: AuthResponse = await this.authService.reAuthUser();
    
    if(result){
      let response = await this.authService.accountDeletionRequest();
      if(response && response.result){
        this.authService.openSnackBar('Please confirm email to continue deletion process','Ok');
        this.authService.logout();
      }
    }
  }

  selectSection(event: Event, sectionId: string) {
    event.preventDefault();
    this.activeSection = sectionId;
    this.handleDataLoading(sectionId);
  }
  
  async handleDataLoading(tab: string){
    this.activeSection = tab;
    switch(tab){
      case 'billing':
        this.loadSubInfo();
      break;

      default:
        this.activeSection = 'account';
        this.loadUserData();
      break;
    }
  }

  async loadUserData(){
    this.userInfo = await this.authService.getUserData();
  
  }

  async loadSubInfo(){
    this.activeSubs = await this.paymentService.getCustomerActiveSubscription();
  }

  async ngOnInit(): Promise<void> {
    this.activeSubs = [];
    this.userInfo = new UserInfo();
    
    this.handleDataLoading(this.activeSection);
    
    this.route.queryParams.subscribe(async params =>{
        let tab: string = params['tab'];
        if(tab === 'billing'){
          const s = await this.paymentService.checkForActiveSubscription();
          if(s){
            this.authService.updateAuthState(s);
          }
        }
        this.handleDataLoading(tab);
    });
  
  }

}
